import {
  calcTotalCount,
  Progress,
  sumProgressCount,
} from "../../../../domains/DrillProgress";
import { DrillProgressBarGroup } from "../../DrillProgressBarGroup";

type Props = {
  progress?: Progress;
  rounded?: boolean;
  invisible?: boolean;
  showTotalCount?: boolean;
  bold?: boolean;
};

export const TimelineDrillProgressBar = ({
  progress,
  rounded,
  invisible,
  showTotalCount = false,
  bold = false,
}: Props) => {
  const displayProgress: Progress = progress ?? {
    notStudiedCount: 0,
    studyingCount: 0,
    establishedCount: 0,
    perfectCount: 0,
    studiedCount: 0,
  };

  const totalCount = calcTotalCount(displayProgress);
  const actualCount = sumProgressCount(displayProgress);

  return (
    <div
      className={`flex w-full flex-col ${invisible ? "invisible" : ""}`}
      data-testid="drill-progress-bar"
    >
      {showTotalCount && <div>コンテンツ：{actualCount}</div>}
      <div
        className={`flex w-full ${rounded ? "overflow-hidden rounded-full" : ""}`}
      >
        <DrillProgressBarGroup
          totalCount={totalCount}
          progress={displayProgress}
          bold={bold}
        />
      </div>
    </div>
  );
};
